module.exports = "<div fxLayout=\"row wrap\">\r\n  <div fxFlex class=\"flex-p\"> <h4>Procurar...</h4></div>\r\n</div>"